import config from "constants/config";
import * as Yup from "yup";


export const initialValuesInfo = {
	title: '',
	description: '',
	type: 'INFO_CARD',
	unlisted: 0,
	private: 0,
	sort_priority: 1,
	image: [],
}

export const initialValues = {
	title: '',
	price: '',
	description: '',
	default_image: '',
	license_period: null,
	youtube_link: '',
	affiliate_revenue_percent: -1,
	price_variants: '',
	currency: '',
	gateways: '',
	type: null,
	marketplace_category_id: '',
	price_discount: 0,
	serials: '',
	service_text: '',
	stock: -1,
	dynamic_webhook: '',
	stock_delimiter: config.DELIMITER_OPTIONS[0].value,
	quantity_min: 0,
	quantity_max: 0,
	label_singular: "",
	label_plural: "",
	subtype: null,
	delivery_text: '',
	redirect_link: '',
	custom_fields: '',
	volume_discounts: '',
	crypto_confirmations_needed: 0,
	max_risk_level: 85,
	unlisted: false,
	private: false,
	block_vpn_proxies: false,
	slug: "",
	on_hold: false,
	tos_enabled: false,
	watermark_enabled: false,
	redirect_enabled: false,
	warranty_enabled: false,
	delivery_text_enabled: false,
	watermark_text: '',
	serials_remove_duplicates: false,
	sort_priority: 1,
	image: [],
	file: [],
	manuallyWarranty: 900,
	warranty: 0,
	warranty_text: '',
	terms_of_service: '',
	pay_what_you_want: '0',
	recurring_interval: config.RECURRING_INTERVAL[0].value,
	recurring_interval_count: 7,
	stripe_price_id: "",
	trial_period: 0,
	discord_integration: false,
	discord_optional: false,
	discord_server_id : "none",
	discord_role_id: "",
	discord_set_role: false,
	discord_remove_role: false,
	telegram_integration: false,
	telegram_group_id: "none",
	telegram_optional: false,
}

export const validationSchemaInfo = Yup.object().shape({
	title: Yup.string().required('Title is required'),
	description: Yup.string().required('Description is required'),
	type: Yup.string(),
	sort_priority: Yup.number()
});

export const validationSchema = Yup.object().shape({
	title: Yup.string().required('Title is required'),
	price: Yup.number().required('Price is required'),
	description: Yup.string().required('Description is required'),
	currency: Yup.string().required('Currency is required'),
	type: Yup.string().required('Product type is required'),

	price_discount: Yup.number(),
	affiliate_revenue_percent: Yup.number(),
	youtube_link: Yup.string().nullable(),

	recurring_interval: Yup.mixed().oneOf(config.RECURRING_INTERVAL.map(({ value }) => value)).nullable(),
	recurring_interval_count: Yup.number().required('Enter interval count'),
	trial_period: Yup.number().nullable(),

	custom_fields: Yup.string().nullable(),
	gateways: Yup.string(),
	subtype: Yup.string().nullable(),
	warranty: Yup.number().nullable(),
	manuallyWarranty: Yup.number().nullable(),
	serials: Yup.string(),
	service_text: Yup.string().nullable(),
	dynamic_webhook: Yup.string().nullable(),
	licensing_enabled: Yup.boolean(),
	license_period: Yup.number().when('licensing_enabled', (licensingEnabled, schema) => {
		return licensingEnabled ? schema.required('License period is required') : schema;
	}).nullable(),
	stock: Yup.number(),
	quantity_min:
		Yup.number()
			.transform((value, originalValue) => String(originalValue).trim() === "" ? null : value)
			.nullable(),
	quantity_max:
		Yup.number()
			.min(Yup.ref("quantity_min"), "Maximum must be greater than or equal to Minimum")
			.nullable()
			.transform((value, originalValue) => {
				return (String(originalValue).trim() === "" || originalValue == -1 || originalValue == 0) ? null : value
			}),
	stock_delimiter: Yup.string(),
	delivery_text: Yup.string().nullable(),
	crypto_confirmations_needed: Yup.number(),
	max_risk_level: Yup.number(),
	sort_priority: Yup.number(),
	warranty_text: Yup.string().nullable(),
	terms_of_service: Yup.string().nullable(),
	discord_integration: Yup.bool().nullable(),
	discord_optional: Yup.bool().nullable(),
	discord_server_id :Yup.string().nullable(),
	discord_set_role: Yup.bool().nullable(),
	discord_role_id:Yup.string().nullable(),
	discord_remove_role: Yup.bool().nullable(),
})

export const validationSchemaVariant = Yup.object().shape({
	title: Yup.string(),
	price: Yup.number(),
	description: Yup.string().required('Description is required'),
	currency: Yup.string().required('Currency is required'),
	type: Yup.string().required('Product type is required'),
	affiliate_revenue_percent: Yup.number(),
	price_discount: Yup.number(),
	youtube_link: Yup.string().nullable(),

	recurring_interval: Yup.mixed().oneOf(config.RECURRING_INTERVAL.map(({ value }) => value)).nullable(),
	recurring_interval_count: Yup.number().required('Enter interval count'),
	trial_period: Yup.number().nullable(),

	custom_fields: Yup.string().nullable(),
	gateways: Yup.string(),
	subtype: Yup.string().nullable(),
	warranty: Yup.number().nullable(),
	manuallyWarranty: Yup.number().nullable(),
	// serials: Yup.string().any(),
	service_text: Yup.string().nullable(),
	dynamic_webhook: Yup.string().nullable(),
	stock: Yup.number(),
	quantity_min:
		Yup.number()
			.transform((value, originalValue) => String(originalValue).trim() === "" ? null : value)
			.nullable(),
	quantity_max:
		Yup.number()
			.min(Yup.ref("quantity_min"), "Maximum must be greater than or equal to Minimum")
			.nullable()
			.transform((value, originalValue) => {
				return (String(originalValue).trim() === "" || originalValue == -1 || originalValue == 0) ? null : value
			}),
	stock_delimiter: Yup.string().nullable(),
	delivery_text: Yup.string().nullable(),
	crypto_confirmations_needed: Yup.number(),
	max_risk_level: Yup.number(),
	sort_priority: Yup.number(),
	warranty_text: Yup.string().nullable(),
	terms_of_service: Yup.string().nullable(),
})
